module.exports = __webpack_public_path__ + "static/media/Vincent Crabbe 1.9fb73b62.jpg";